// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"867fb562e14902ed22e0","263":"633504d8fe9ff0ef3d39","791":"d9a24b2d9c66386ce3f2"}[chunkId] + ".js";
};